import { render, staticRenderFns } from "./prohibitedClass.vue?vue&type=template&id=2289f25b&scoped=true"
import script from "./prohibitedClass.vue?vue&type=script&lang=js"
export * from "./prohibitedClass.vue?vue&type=script&lang=js"
import style0 from "./prohibitedClass.vue?vue&type=style&index=0&id=2289f25b&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2289f25b",
  null
  
)

export default component.exports